import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { Container, Row, Col } from "reactstrap"
import {
  getpchAssessmentsData,
  getResidentAssessmentsData,
  getResidentUsersData,
} from "../../store/actions"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import CompanyTable from "./Company-Table"

const Dashboard = props => {
  const dispatch = useDispatch()
  const themeColor = useSelector(state => state.theme.color)

  useEffect(() => {
    document.documentElement.style.setProperty("--scrollbar-color", themeColor)
  }, [themeColor])

  useEffect(() => {
    // dispatch(getResidentAssessmentsData())
    // dispatch(getpchAssessmentsData())
  }, [dispatch])

  //meta title
  document.title = "Company Dashboard - ColdBlock Technologies Inc."

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          {/* <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          /> */}
          <Row>
            <Col lg="12">
              <CompanyTable />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  getResidentAssessmentsData: PropTypes.func,
}

export default withTranslation()(Dashboard)
